export default __webpack_public_path__ + "static/media/footer-bg.99c66e82.svg";